(function () {
  function ProductHeaderHelper(productSelector) {
    var originalHeader = document.querySelector(productSelector + ' .product__header');
    if (!originalHeader) return;

    var productRoot = document.querySelector(productSelector);
    var productHeaderEl = document.querySelector(productSelector + ' product-header');
    if (!productRoot || !productHeaderEl) return;

    var duplicateHeader = document.createElement('div');
    duplicateHeader.className = 'product__header-mobile hide smaller-lap--show-block';
    duplicateHeader.innerHTML = productHeaderEl.innerHTML;

    var priceEl = duplicateHeader.querySelector('.product__price');
    if (priceEl) priceEl.id = '';

    productRoot.prepend(duplicateHeader);
    duplicateHeader = duplicateHeader.querySelector('.product__header');
    if (!duplicateHeader) return;

    var headerObserver = new MutationObserver(function () {
      duplicateHeader.innerHTML = originalHeader.innerHTML;
    });
    headerObserver.observe(originalHeader, { attributes: false, childList: true, subtree: true });
  }

  window.ProductHeaderHelper = ProductHeaderHelper;
})();
